<template>
  <div class="col-12 col-lg-8 c">
    <div class="border shadow card">
        <div class="card-body shadow border text-center" v-if="!current._id">
            جاري الاستعلام...
        </div>
        <div class="card-body shadow border" v-if="current._id">
            <h4 class="text-center">
                <i class="fa fa-phone"></i>
                تغيير رقم الجوال
            </h4>
            <div class="form-group">
              <h5 for="">الاسم</h5>
              <input type="text"
                class="form-control bg-white" v-model="current.name" readonly>
            </div>
            <div class="form-group">
              <h5 for="">الجوال الحالي</h5>
              <input type="text"
                class="form-control bg-white" v-model="current.phone" readonly>
            </div>
            <div class="form-group">
              <h5 for="">رقم الجوال الجديد</h5>
              <input type="number"
                class="form-control form-control-lg text-center" style="border: 2px solid #3D8D7A !important" v-model="newphone" placeholder="اكتب الرقم الجديد هنا...">
            </div>
            <div class="col-12 text-center">
                <button class="btn btn-success" @click="changeNow()">
                    <i class="fa fa-check"></i>
                    تغيير الرقم الآن
                </button>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
    data(){
        return {
            id: window.location.href.split("changephone/")[1],
            current: {},
            newphone: ""
        }
    },
    created(){
        var g = this;
        $.post(api + '/user/web/change-phone', {
            id: this.id
        })
        .then(function(r){
            if(r.status == 100){
                g.current = r.response
            }else{
                alert(r.response, 200)
            }
        })
        .fail(function(){
            alert("حدث خطأ في الاتصال", 200)
        })
    },
    methods: {
        changeNow(){
            var g = this;
            if(!g.newphone || g.newphone == ""){
                return alert("برجاء كتابة الرقم الجديد", 200)
            }
            $.post(api + '/user/web/change-phone-now', {
                id: this.id,
                phone: this.newphone
            })
            .then(function(r){
                if(r.status == 100){
                    alert("تم التغيير بنجاح", 100)
                }else{
                    alert(r.response, 200)
                }
            })
            .fail(function(){
                alert("حدث خطأ في الاتصال", 200)
            })
        }
    }
}
</script>

<style>

</style>